export default "__VITE_ASSET__uIROBCo1__"